// 当前时间
function dateTime() {
    let time = new Date();
    let n = time.getFullYear();
    let y = time.getMonth() + 1;
    let r = time.getDate();
    let s = time.getHours();
    let f = time.getMinutes();
    let m = time.getSeconds();

    y = y > 9 ? y : "0" + y;
    r = r > 9 ? r : "0" + r;
    s = s > 9 ? s : "0" + s;
    f = f > 9 ? f : "0" + f;
    m = m > 9 ? m : "0" + m;

    let dataTime = n + "-" + y + "-" + r + " " + s + ":" + f + ":" + m;
    return dataTime;
}

export {
    dateTime
}